export const formatDuration = (seconds: number): string => {
  const total = Math.max(0, Math.floor(seconds));
  const h = Math.floor(total / 3600)
    .toString()
    .padStart(2, '0');
  const m = Math.floor((total % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(total % 60)
    .toString()
    .padStart(2, '0');
  return `${h}:${m}:${s}`;
};

export const runningDuration = (startedAt: string): number =>
  Math.max(0, Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000));

// Human-readable duration ("2 h 5 m" / "12 m") — never raw seconds in stats/UI.
export const formatHours = (seconds: number): string => {
  const total = Math.max(0, Math.floor(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  if (h === 0) {
    return `${m} m`;
  }
  return `${h} h ${m} m`;
};

// SQLite writes "YYYY-MM-DD HH:MM:SS" in UTC without a marker; the browser would
// read that as local time and show a comment as hours old the moment it lands.
export const normalizeIso = (value: string): string =>
  value.includes('T') ? value : `${value.replace(' ', 'T')}Z`;

export const formatRelativeTime = (iso: string): string => {
  const diffMs = Date.now() - new Date(iso).getTime();
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) {
    return 'práve teraz';
  }
  if (minutes < 60) {
    return `pred ${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `pred ${hours} h`;
  }
  const days = Math.floor(hours / 24);
  if (days < 7) {
    return `pred ${days} d`;
  }
  return new Date(iso).toLocaleDateString('sk-SK', { day: '2-digit', month: '2-digit' });
};

export const formatDateTime = (iso: string): string =>
  new Date(iso).toLocaleString('sk-SK', {
    hour: '2-digit',
    minute: '2-digit',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

export const toInputDateTime = (date: Date): string => {
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60_000);
  return local.toISOString().slice(0, 16);
};
